import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import Select from 'react-select'

class PosStorePriceModificationForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading:false,
      isEdit: false,
      isCopy: false,
      productList: [],
      selected_product:null,
      store_id: '',
      id: '',
      product_id: '',
      price: '',
      unit: '',
      min_qty: '',
      max_qty: '',
      start_dt: '',
      end_dt: '',
    }
  }

  componentDidMount() {
    console.log(this.props.data)
    let data = this.props.data
    if (this.props.data.isEdit || this.props.data.isCopy) {
      let sdata = this.props.data.pricemod.find(x => x.id === this.props.data.selectedId)
      let selected_product = this.props.data.productList.find(x=>x.id == sdata.product_id)
      this.setState({
        isEdit: data.isEdit,
        isCopy: data.isCopy,
        id: sdata.id,
        store_id: data.store_id,
        product_id: sdata.product_id,
        price: sdata.price,
        unit: sdata.unit,
        min_qty: sdata.min_qty,
        max_qty: sdata.max_qty,
        start_dt: sdata.start_dt,
        end_dt: sdata.end_dt,
        productList: data.productList,
        selected_product: [{label:selected_product.product_no + " "+selected_product.name, value:selected_product.id}]
      })
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        productList: data.productList,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

    productMultipleHandler = selected_product => {
   
    this.setState({
      selected_product: selected_product,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (!this.state.isEdit) {
      if(this.state.isCopy){

        if(this.state.selected_product.length>0){
          this.setState({isLoading:true})
          this.copy(user, comp, url)
        }else{
          this.notificationSystem.addNotification({
              title: '',
              message: 'Please select at least 1 product',
              level: 'info',
              position: 'tc',
              autoDismiss: 2,
              dismissible: 'click',
            })
        }

      }else{
        this.create(user, comp, url)
      }
    } else {
      this.edit(user, comp, url)
    }
  }

  create(user, comp, url) {
    let price_data = [{ unit: this.state.unit, price: this.state.price }]

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      price_data: JSON.stringify(price_data),
      min_qty: this.state.min_qty,
      max_qty: this.state.max_qty,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      created_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'Price Modification added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

    async copy(user, comp, url) {

      let result = await this.state.selected_product.map(i=>{

      let price_data = [{ unit: this.state.unit, price: this.state.price }]

      const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        store_id: this.state.store_id,
        product_id: i.value,
        price_data: JSON.stringify(price_data),
        min_qty: this.state.min_qty,
        max_qty: this.state.max_qty,
        start_dt: this.state.start_dt,
        end_dt: this.state.end_dt,
        created_by: user.email,
      }

      axios
        .post(url + ':3002/v1/product/store/detail/price_mod/add', data)
        .then(response => {
          const result = response.data
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false)
            return
          }

          return
        })
        .catch(error => {
          alert(error)
        })

      })

      setTimeout(() => {
        this.setState({isLoading:false})
        this.props.closeModal(<MdDone />, 'Product Modification added successfully.', 'success', false)
      }, this.state.selected_product.length * 100);
    
  }

  edit(user, comp, url) {
    let price_data = [{ unit: this.state.unit, price: this.state.price }]

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      price_id: this.state.id,
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      price_data: JSON.stringify(price_data),
      min_qty: this.state.min_qty,
      max_qty: this.state.max_qty,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/price_mod/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Price Modification updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {

        let options = [
      ...this.state.productList
        .reduce((r, o) => {
          let key = o.id;
          let item = { value: o.id, label: o.product_no + " " +o.name };
          return r.set(key, item);
        }, new Map())
        .values(),
    ];
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
          <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
           {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <ModalHeader toggle={this.props.onToggleModal()}>Price Modification</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Product</Label>
               {
                this.state.isCopy?
                  <Select
                    isMulti
                    //defaultValue = {[options[defaultIndex]]}
                    value= {this.state.selected_product}
                    options={options}
                    name="product_id"
                    //onChange={setselectedservices}
                    onChange={this.productMultipleHandler}
                    menuPosition={'fixed'}
                    required
                  />
                :
                 <Input type="select" name="product_id" value={this.state.product_id} onChange={this.changeHandler} disabled={this.state.isEdit} required>
                  <option></option>
                  {this.state.productList.length > 0 &&
                    this.state.productList.map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.product_no} - {item.name}
                        </option>
                      )
                    })}
                    </Input>
               }
              </FormGroup>
              <FormGroup>
                <Label>Price</Label>
                <Input type="number" name="price" value={this.state.price} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Min Quantity</Label>
                <Input type="number" name="min_qty" value={this.state.min_qty} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Max Quantity</Label>
                <Input type="number" name="max_qty" value={this.state.max_qty} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Start Date</Label>
                <Input type="date" name="start_dt" value={this.state.start_dt} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>End Date</Label>
                <Input type="date" name="end_dt" value={this.state.end_dt} onChange={this.changeHandler} required />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosStorePriceModificationForm
